import CompanyData from "./CompanyData";
import Artists from "./Artists";

const comp = CompanyData[0];

const validArtists = Artists.filter((artist) => artist.url);

let NavBarList = [
  {
    label: "Home",
    url: "home",
  },
  {
    label: "Our Work",
    url: "portfolio",
  },
  {
    label: "Book Now",
    url: "booknow",
  },
  {
    label: "Contact",
    url: "contact",
  },
  // {
  //   label: "Contact",
  //   url: "contact",
  //   dropdownItems: [
  //     { label: "Email Us", url: "/email" },
  //     { label: "Call Us", url: "/call" },
  //   ],
  // },
];

// Add the Artists link only if there are valid artists
if (validArtists.length > 0) {
  NavBarList.splice(1, 0, {
    label: "Artists",
    url: "artists", // You can update this URL if needed
    dropdownItems: validArtists.map((artist) => ({
      label: artist.name,
      url: `/artist/${artist.url}`, // Assuming `url` is the artist's unique URL
    })),
  });
}

// Check if comp.phone exists and add it to the NavBarList if so
if (comp.phone) {
  NavBarList.push({
    label: (
      <div className="flex items-center">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          className="mr-[7px] md:[fill:#fff]"
          width="18px"
          height="18px"
        >
          <path d="M21.384,17.752a2.108,2.108,0,0,1-.522,3.359,7.543,7.543,0,0,1-5.476.642C10.5,20.523,3.477,13.5,2.247,8.614a7.543,7.543,0,0,1,.642-5.476,2.108,2.108,0,0,1,3.359-.522L8.333,4.7a2.094,2.094,0,0,1,.445,2.328A3.877,3.877,0,0,1,8,8.2c-2.384,2.384,5.417,10.185,7.8,7.8a3.877,3.877,0,0,1,1.173-.781,2.092,2.092,0,0,1,2.328.445Z"></path>
        </svg>
        {comp.phone}
      </div>
    ),
    url: `tel:${comp.phone}`,
    type: "tel",
  });
}

export default NavBarList;
